import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { AddShoppingCartItemWithReg, ProductDto, UserAccountRegDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { ProductService } from 'src/app/core/services/product.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';

@Component({
  selector: 'app-order-hardcopy-score-service',
  templateUrl: './order-hardcopy-score-service.component.html',
  styleUrls: ['./order-hardcopy-score-service.component.scss']
})
export class OrderHardcopyScoreServiceComponent implements OnInit {
  hardcopyScoresServiceProducts: ProductDto[] = [];
  regId: number;
  selectedHardcopyScoresServiceProduct: ProductDto;
  testTypeId: number;
  testInfo: UserAccountRegDto;

  constructor(
    private actRoute: ActivatedRoute,
    private productService: ProductService,
    private registrationService: RegistrationService,
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private toastService: HotToastService,
  ) {
    this.regId = Number(this.actRoute.snapshot.params.id);
  }

  ngOnInit(): void {
    this.getTestInfo(this.regId);
    this.getScoreOptions(this.regId);
  }

  addScoreReportToCart() {
    const addProduct: AddShoppingCartItemWithReg = {
      orderActionNotes: '',
      productId: this.selectedHardcopyScoresServiceProduct.id,
      regId: this.regId,
    };

    this.shoppingCartService.addItemWithReg(addProduct).subscribe(
      () => {
        this.router.navigate(['shopping-cart']);
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  getTotalAmount() {
    if (this.selectedHardcopyScoresServiceProduct != null) {
      return this.selectedHardcopyScoresServiceProduct.listPrice;
    }
  }

  getTestInfo(regId: number) {
    this.registrationService.getTestInfo(regId).subscribe(result => {
      this.testTypeId = Number(result.content.testTypeId);
      this.testInfo = result.content;
    },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  getHardcopyScoresServiceDisplayName(serviceProduct) {
    switch (serviceProduct.id) {
      case 6002:
        return "Regular mail (2-10 business days within Canada and the United States, 2-3 weeks internationally from the time it is shipped from our office) - " + serviceProduct.currencyCode + " " + serviceProduct.listPrice.toFixed(2);
      case 6003:
        return "Priority shipping within Canada and the United States (2-4 business days from the time it is shipped from our office) - " + serviceProduct.currencyCode + " " + serviceProduct.listPrice.toFixed(2);
      case 6004:
        return "Priority shipping internationally (3-7 business days from the time it is shipped from our office) - " + serviceProduct.currencyCode + " " + serviceProduct.listPrice.toFixed(2);
    }
  }

  getScoreOptions(regId: number) {
    this.productService.getHardCopyShippingProducts(regId).subscribe(
      result => {
        this.hardcopyScoresServiceProducts = result.content.sort((a, b) => a.listPrice - b.listPrice);
        this.selectedHardcopyScoresServiceProduct = this.hardcopyScoresServiceProducts[0];
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  selectHardcopyScoresServiceProduct(serviceProduct: ProductDto) {
    this.selectedHardcopyScoresServiceProduct = serviceProduct;
  }
}
